import { AxiosError } from 'axios';
import { Alert } from '../../components/Toast/Alert';
import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { services } from 'service';
import { PaymentDto, PaymentResponseDto } from 'service/dto/payment.dto';
import { Plan } from 'types/general.type';

export const useInitializePaymentMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(
    (payment: PaymentDto): Promise<PaymentResponseDto> => {
      return services.paymentService.initializePayment(payment);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries(['payment-initialize']);
      },
      onError: (error: Error) => {
        toast.error(<Alert message={error.message} type="error" />);
      }
    }
  );
};

export const useGetPlans = () => {
  return useQuery<Plan[], AxiosError<Error>>(
    ['get_plans'],
    () => services.paymentService.getAllPlans(),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false
    }
  );
};

export const useGetAPlan = ({ planId }: { planId: number }) => {
  return useQuery<Plan, AxiosError<Error>>(
    ['get_plan', planId],
    () => services.paymentService.getAPlan(planId),
    {
      keepPreviousData: false,
      refetchOnWindowFocus: false,
      enabled: !!planId
    }
  );
};
